import React from 'react';

const About = ({ data }) => {
    if (data) {
        var name = data.name;
        var profilepic = '/images/' + data.image;
        var bio = data.bio;
        var country = data.address.country;
        var state = data.address.state;
        var phone = data.phone;
        var email = data.email;
    }

    return (
        <section id="about">
            <div className="row">
                <div className="three columns">
                    <img
                        className="profile-pic"
                        src={profilepic}
                        alt="Mason's Profile Pic"
                    />
                </div>
                <div className="nine columns main-col">
                    <h2>About Me</h2>

                    <p>{bio}</p>
                    <div className="row">
                        <div className="columns contact-details">
                            <h2>Contact Details</h2>
                            <p className="address">
                                <span>{name}</span>
                                <br />
                                <span>
                                    {state}, {country}
                                </span>
                                <br />
                                <span>{phone}</span>
                                <br />
                                <span>{email}</span>
                            </p>
                        </div>
                        <div className="columns download">
                            <p>
                                <a
                                    href="https://www.yumpu.com/en/document/view/71067093/mason-garrett"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className="button"
                                >
                                    <i className="fa fa-download"></i>Download
                                    Resume
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
